import RetireSpokePage from "@/components/retire-spoke/RetireSpokePage";

const RetireAt60 = () => <RetireSpokePage age={60} />;

export default RetireAt60;
